export default __webpack_public_path__ + "static/media/DrukTextWide-Medium.a2233fef.woff";